module.exports = __webpack_public_path__ + "media/coffee-preferences/fine_grind-cd1817e9.png";